module.exports = __webpack_public_path__ + "img/image_32.c48fdbad.png";